module.exports = __webpack_public_path__ + "static/img/img-default-2.b62a685.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-default-2.jpg
// module id = LAXM
// module chunks = 2